<template>
  <div class="bg-card-grey mt-3">
    <div class="cardy-body-noBorder">
      <div>
        <h4 class="color-dark-purple mb-3">ANOTAÇÕES</h4>
      </div>
      <div v-for="item in notes_candidate" :key="item.id">
        <div>
          <div
            class="icon-flutuant-close-tb pointer"
            @click="deleteNote(item.id)"
          >
            <i class="fas fa-times color-purple"></i>
          </div>
          <span>{{ item.note }}</span>
        </div>
        <div>
          <span> Recrutador(a): {{ item.recruiter.name }}</span>
        </div>
        <div>
          <hr />
        </div>
      </div>
      <div>
        <button
          style="width: 100%"
          class="color-white btn-add-items-tb bg-purple"
          v-if="!showForm"
          @click="showForm = true"
        >
          ADICIONAR ANOTAÇÃO
        </button>
      </div>

      <div v-if="showForm">
        <textarea
          class="full form-control mt-3 mb-3"
          :class="{
            'is-invalid': notes.note.length !== 0 && notes.note.length <= 3,
          }"
          cols="30"
          rows="10"
          style="height: 100px; border-radius: 5px"
          v-model="notes.note"
        ></textarea>
        <div class="d-flex">
          <button
            class="btn btn-danger to_uppercase full"
            @click="showForm = false"
          >
            Cancelar
          </button>
          <button class="btn btn-primary full" @click="sendNote()">
            SALVAR
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dateFilter } from "vue-date-fns";

export default {
  props: ["candidate_id"],
  data: () => ({
    notes: {
      note: "",
    },
    showForm: false,
    notes_candidate: [],
  }),
  mounted() {
    this.getNotes();
  },
  methods: {
    getNotes() {
      axios
        .get(`/recruiters/talent_banks/${this.candidate_id}/candidate/notes`)
        .then((response) => {
          this.notes_candidate = response.data.notes;
        });
    },
    deleteNote(id) {
      let conf = confirm("Deseja realmente apagar essa anotação?");
      if (!conf) return;
      axios
        .delete(
          `/recruiters/talent_banks/${this.candidate_id}/candidate/notes/${id}`
        )
        .then((response) => {
          this.getNotes();
          response.data.isDeleted == true
            ? this.$toast.success("Nota removida com sucesso")
            : this.$toast.error("Você não pode remover essa nota");
        });
    },
    sendNote() {
      if (this.notes.note.length < 3) return;
      axios
        .post(`/recruiters/talent_banks/${this.candidate_id}/candidate/note`, {
          notes: {
            note: this.notes.note,
          },
        })
        .then((response) => {
          this.notes = {
            note: "",
          };
          this.showForm = false;
          this.getNotes();
          this.$toast.success("Nota adicionada com sucesso");
        });
    },
  },
};
</script>